<template>
  <div>
    <Head :title="__(title)" />
    <div class="mb-6 flex justify-between items-center">
     
      <Link class="btn-indigo" :href="this.route('venciment-color.create')">
        <span>{{ __('Create New') }}</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">{{ __('Description') }}</th>
          <th class="px-6 pt-6 pb-4">{{ __('# Days') }}</th>
           <th class="px-6 pt-6 pb-4">{{ __('# Days Max ') }}</th> 
          <th class="px-6 pt-6 pb-4">{{ __('Color') }}</th>
        </tr>
        <tr v-for="type in types.data" :key="type.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('venciment-color.edit', type.id)">
              {{ type.description }}
            </Link>
          </td>
          <td class="border-t">
            <Link v-if="type.nday" class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('venciment-color.edit', type.id)">
              {{ type.nday }} día(s)
            </Link>
          </td>
         
          <td class="border-t">
            <Link v-if="type.nday" class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('venciment-color.edit', type.id)">
              {{ type.ndaymax }} día(s)
            </Link>
          </td>
        
          <td class="border-t">
            <Link v-if="type.color" class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('venciment-color.edit', type.id)">
              <div class="rounded p-3" :style="{ background: type.color}"></div>  
            </Link>
          </td>
          <td class="border-t w-px">
            <Link class="px-4 flex items-center" :href="this.route('venciment-color.edit', type.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="types.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">{{ __('No types found') }}.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="types.links" />
  </div>
</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'

export default {
  metaInfo: { title: 'Types' },
  components: {
      SearchInput,
    Icon,
    Link,
    Head,
    Pagination,
  },
  layout: Layout,
  props: {
      title: String,
    filters: Object,
    types: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('venciment-color'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
